import { getIconStyle } from '@/storybook/icons/iconUtils';
import React from 'react';

export const InfoIcon = ({ fill = '#544F4F', ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 18 19" fill="none" {...props}>
      <g id="info_black_24dp 1" clipPath="url(#clip0_21954_904)">
        <path
          id="Vector"
          d="M8.25 5.36914H9.75V6.86914H8.25V5.36914ZM8.25 8.36914H9.75V10.6191V12.8691H8.25V8.36914ZM9 1.61914C4.86 1.61914 1.5 4.97914 1.5 9.11914C1.5 13.2591 4.86 16.6191 9 16.6191C13.14 16.6191 16.5 13.2591 16.5 9.11914C16.5 4.97914 13.14 1.61914 9 1.61914ZM9 15.1191C5.6925 15.1191 3 12.4266 3 9.11914C3 5.81164 5.6925 3.11914 9 3.11914C12.3075 3.11914 15 5.81164 15 9.11914C15 12.4266 12.3075 15.1191 9 15.1191Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_21954_904">
          <rect width="18" height="18" fill="white" transform="translate(0 0.119141)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClosePopupIcon = ({ fill = '#706B69', ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g id="Cut outline S / Navigation / Caret down">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.974 6.436L17.565 5.026L12 10.59L6.411 5L5 6.41L10.59 12L5 17.59L6.411 19L12 13.41L17.59 19L19 17.59L13.411 12L18.974 6.436Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const CloseIcon = ({ fill = '#8C0000', style, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" style={getIconStyle(fill, style)} {...props}>
      <g id="Outline/close_circle">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.69592C6.47715 2.69592 2 7.17308 2 12.6959C2 18.2188 6.47715 22.6959 12 22.6959C17.5228 22.6959 22 18.2188 22 12.6959C22 7.17308 17.5228 2.69592 12 2.69592ZM12 4.69592C16.4183 4.69592 20 8.27764 20 12.6959C20 17.1142 16.4183 20.6959 12 20.6959C7.58172 20.6959 4 17.1142 4 12.6959C4.00496 8.2797 7.58378 4.70088 12 4.69592ZM15 17.1789L16.483 15.6959L13.483 12.6959L16.483 9.69592L15 8.21292L12 11.2129L9 8.21292L7.517 9.69592L10.517 12.6959L7.517 15.6959L9 17.1789L12 14.1789L15 17.1789Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const CheckmarkCircleIcon = ({ fill = '#00513E', style, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" style={getIconStyle(fill, style)} {...props}>
      <g id="Outline/checkmark_circle">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.8616C6.47715 2.8616 2 7.2253 2 12.6082C2 17.9911 6.47715 22.3548 12 22.3548C17.5228 22.3548 22 17.9911 22 12.6082C22 7.2253 17.5228 2.8616 12 2.8616ZM12 4.81092C16.4183 4.81092 20 8.30188 20 12.6082C20 16.9145 16.4183 20.4055 12 20.4055C7.58172 20.4055 4 16.9145 4 12.6082C4.00496 8.30388 7.58378 4.81575 12 4.81092ZM18 10.0936L16.59 8.70956L11 14.1579L8.41 11.6433L7 13.0175L11 16.9162L18 10.0936Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const WarningCircle = ({ fill = 'var(--grey-500)', style, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" style={getIconStyle(fill, style)} {...props}>
      <g id="Outline/warning_circle">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12.3918C2 7.00893 6.47715 2.64523 12 2.64523C17.5228 2.64523 22 7.00893 22 12.3918C22 17.7747 17.5228 22.1384 12 22.1384C6.47715 22.1384 2 17.7747 2 12.3918ZM19.487 9.36726C18.2317 6.41735 15.2766 4.49511 12 4.49709C7.52845 4.49978 3.905 8.03358 3.905 12.3918C3.905 15.5854 5.87904 18.4644 8.90642 19.6861C11.9338 20.9077 15.4181 20.2314 17.7343 17.9725C20.0505 15.7136 20.7423 12.3172 19.487 9.36726ZM13 7.51853V13.3665H11V7.51853H13ZM11 15.3158V17.2651H13V15.3158H11Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CheckmarkCircleIconYellow = ({
  fill = 'var(--yellow-500)',
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" style={getIconStyle(fill, style)} {...props}>
      <g id="Outline/checkmark_circle">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.25342C6.47715 2.25342 2 6.61711 2 12C2 17.3829 6.47715 21.7466 12 21.7466C17.5228 21.7466 22 17.3829 22 12C22 6.61711 17.5228 2.25342 12 2.25342ZM12 4.20274C16.4183 4.20274 20 7.69369 20 12C20 16.3063 16.4183 19.7973 12 19.7973C7.58172 19.7973 4 16.3063 4 12C4.00496 7.6957 7.58378 4.20757 12 4.20274ZM18 9.48539L16.59 8.10137L11 13.5497L8.41 11.0351L7 12.4094L11 16.308L18 9.48539Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
